import { c as _c } from "react/compiler-runtime";
import { UserAvatarWithMenu } from "@components/user-more-info-menu/user-avatar-with-menu";
import { Text } from "@flat-ui";
import { useMembers } from "@hooks/use-members";
import { Box } from "@mui-wrapper";
import { getMarkupCreator } from "@pages/project-details/project-markups/markup-details-utils";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { withEllipsis } from "@styles/common-styles";
import { getPrettyName } from "@utils/user-utils";

/** Avatar and name of the member who created the markup */
export function MarkupCreator(t0) {
  const $ = _c(19);
  const {
    markup,
    isSidePanelOpen: t1
  } = t0;
  const isSidePanelOpen = t1 === undefined ? false : t1;
  const {
    companyMembers,
    projectMembers
  } = useMembers();
  const currentUser = useAppSelector(currentUserSelector);
  const isCurrentUser = markup.createdBy === currentUser?.identity;
  let t2;
  if ($[0] !== companyMembers || $[1] !== currentUser || $[2] !== isCurrentUser || $[3] !== markup.createdBy || $[4] !== projectMembers) {
    t2 = getMarkupCreator({
      creatorId: markup.createdBy,
      companyMembers,
      projectMembers
    }) ?? (isCurrentUser ? currentUser : undefined);
    $[0] = companyMembers;
    $[1] = currentUser;
    $[2] = isCurrentUser;
    $[3] = markup.createdBy;
    $[4] = projectMembers;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const creator = t2;
  const t3 = isSidePanelOpen ? 0 : 1;
  let t4;
  if ($[6] !== t3) {
    t4 = {
      display: "flex",
      alignItems: "center",
      width: "100%",
      height: "100%",
      px: t3,
      gap: 1.25
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== creator || $[9] !== isSidePanelOpen) {
    t5 = creator && <UserAvatarWithMenu member={creator} size={isSidePanelOpen ? "x-small" : "small"} />;
    $[8] = creator;
    $[9] = isSidePanelOpen;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== creator) {
    t6 = getPrettyName(creator) || "-";
    $[11] = creator;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <Text variant="bodyS" component="var" sx={withEllipsis}>{t6}</Text>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t7) {
    t8 = <Box sx={t4}>{t5}{t7}</Box>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}